import {addressListsModules}      from "@Common/ui-components/heavy/item-options/modules/address-lists/address-lists-modules";
import {sampleMailingCardModules} from "@Common/ui-components/heavy/item-options/modules/sample-mailing-card/sample-mailing-card-modules";

import {addressableShippingModules}    from "./addressable-shipping/addressable-shipping-modules";
import {bulkMailPermitModules}         from "./bulk-mail-permit/bulk-mail-permit-modules";
import {deliveryMethodsModules}        from "./delivery-methods/delivery-methods-modules";
import {downloadDeliveryModules}       from "./download-delivery/download-delivery-modules";
import {futureFulfillmentModules}      from "./future-fulfillment/future-fulfillment-modules";
import {informedDeliveryModules}       from "./informed-delivery/informed-delivery-modules";
import {intelligentMailBarcodeModules} from "./intelligent-mail-barcode/intelligent-mail-barcode-modules";
import {lineItemsModules}              from "./line-items/line-items-modules";
import {ncoaFailedModules}             from "./ncoa/ncoa-failed-modules";
import {paperTypeModules}              from "./paper-type/paper-type-modules";
import {pdfDownloadModules}            from "./pdf-download/pdf-download-modules";
import {quantityModules}               from "./quantity/quantity-modules";
import {addressListsSummary}           from "./summary/address-lists-summary";
import {subTotalSummary}               from "./summary/sub-total-summary";
import {topControlModules}             from "./top-control/top-control-modules";
import {pickupAddressModules}          from "./pickup-address/pickup-address-modules";

export const distributionOptionsModules = ({agent, item, templateOptions, mailingLists, canadaMailing}) => [
    ...deliveryMethodsModules({templateOptions, item}),
    ...pickupAddressModules({}),
    ...addressableShippingModules({item, templateOptions}),
    ...topControlModules({item, templateOptions,}),
    ...downloadDeliveryModules({}),
    ...quantityModules({item}),
    ...paperTypeModules({agent}),
    ...pdfDownloadModules({item}),
    ...ncoaFailedModules({item}),
    ...sampleMailingCardModules({item}),
    ...futureFulfillmentModules({item}),
    ...addressListsModules({entityId: agent?.agentId, item, templateOptions}),
    ...bulkMailPermitModules({item, templateOptions}),
    ...intelligentMailBarcodeModules({item, templateOptions}),
    ...informedDeliveryModules({item, templateOptions}),
    ...lineItemsModules({item, templateOptions}),
    ...addressListsSummary({templateOptions, mailingLists}),
    ...subTotalSummary({item, mailingLists, canadaMailing}),
];
